<template>
    <div v-if="house" class="house-card" :class="{'rented': !house.empty}" :data-id="house.cid" @click="clickEvent"  @mouseenter="changeAddressIcon" @mouseleave="changeAddressIcon">
        <div class="house-card-wrap">
            <img class="video-icon" v-if="house.hasFilm" src="@/assets/img/icon/film.svg" alt="" srcset="">
            <div class="house-view-count h-align">
                <img src="@/assets/img/icon/views.svg" title="點閱次數">
                {{house.houseViewCount}}
                <span class="tips">點閱次數</span>
            </div>
            <div v-if="house.coverImage" class="house-image">
                <img :src="imageUrl(house.coverImage)" alt="">
            </div>
            <div v-else class="house-image">
                <img src="@/assets/img/component/houseCard/default.svg" alt="">
            </div>
            <div class="content-wrap">
                <div class="house-card-title" :class="{'title-gray': house.houseName == '未完善房源' || house.houseName == '紙本合約' }">
                    {{house.houseName}}
                </div>
                <div class="house-card-address">
                    {{house.address}}
                    <img id="address-icon" :src="addressIcon" alt="">
                </div>
                <div class="house-card-price">
                    ${{price}}
                </div>
                <div class="house-state">
                    <!-- 1上架
                    2預定中
                    3已租
                    4下架 -->
                    <span v-if="house.publish" class="put">上架</span>
                    <span v-else class="off">下架</span>
                    <span v-if="house.complete" class="completed">完善</span>
                    <span v-else class="uncompleted">未完善</span>
                    <!-- <span v-if="house.empty">空房</span>
                    <span v-else>已租</span> -->
                </div>
            </div>
        </div>
    </div>
    <div v-else class="house-card loading">
        <div class="house-card-wrap">
            <div class="house-state">
                <span></span>
            </div>
            <img class="house-image" src="@/assets/img/component/houseCard/default.svg" alt="">
            <div class="content-wrap">
                <div class="house-card-title">
                </div>
                <div class="house-card-address">
                </div>
                <div class="house-card-price">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import constant from '@/constant'
export default {
    name: 'HouseCard',
    data () {
        return {
            addressIcon: require('@/assets/img/icon/address_green_border.svg')
        }
    },
    props:{
        house: ''
    },
    methods: {
        changeAddressIcon: function () {
            // console.log(event.target.id  == 'address-icon' )
            // console.log(event.type)
            if( event.type == 'mouseenter' ){
                this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            }else if( event.type == 'mouseleave' ){
                this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            }
            // if( event.type == 'mouseenter' ){
            //     if( event.target.id  == 'address-icon' ){
            //         this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            //     }else{
            //         this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            //     }
            // }else{
            //     if( event.target.id  == 'address-icon' ){
            //         this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            //     }else{
            //         this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            //     }
            // }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        clickEvent: function (){
            window.open('/landlord/housestatus/edithouse?cid='+this.house.cid)
        },
        imageUrl: function (url){
            return constant.imageUrl+url
        }
    },
    computed: {
        price: function () {
            return this.toCurrency(this.house.rentPrice)
        }
    },
}
</script>
<style lang="scss" scoped>
    .house-card{
        position: relative;
        width: 525px;
        // height: 95px;
        background: #fff;
        border-radius: 10px;
        border: solid 1px #d5dad8;
        padding: 20px;
        cursor: pointer;
        .house-card-wrap{
            display: flex;
            align-items: center;
            .video-icon{
                position: absolute;
                bottom: 24px;
                left: 24px;
            }
            .title-gray{
                color: #a8a5a4;
            }
            .house-state{
                position: absolute;
                display: flex;
                align-items: center;
                right: 20px;
                bottom: 16px;
                span{
                    width: 52px;
                    height: 26px;
                    background-color: #cacfcd;
                    color: #fff;
                    font-size: 12px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                span.put{
                    background-color: rgba(113, 170, 229, 0.1);
                    color: #71aae5;
                    margin-right: 8px;
                }
                span.off{
                    background-color: #f3f3f3;
                    color: #676362;
                    margin-right: 8px;
                }
                span.completed{
                    background-color: #71aae5;
                }
                span.uncompleted{
                    background-color: #ff9275;
                }
            }
            .house-view-count{
                position: absolute;
                right: 20px;
                top: 16px;
                >img{
                    margin-right: 4px;
                }
                &:hover {
                    .tips{
                        display: flex;
                    }
                }
                .tips{
                    position: absolute;
                    display: none;
                    align-items: center;
                    justify-content: center;
                    width: 60px;
                    top: 50%;
                    right: -15px;
                    transform: translateY(15px);
                    padding: 4px 5px 4px;
                    border-radius: 4px;
                    background-color: #676362;
                    font-size: 12px;
                    line-height: 1.2;
                    color: #ffffff;
                    text-align: center;
                }
            }
            .house-image{
                width: 120px;
                height: 95px;
                border-radius: 4px;
                margin-right: 16px;
                display: flex;
                align-items: center;
                border-radius: 4px;
                overflow: hidden;
                >img{
                    width: 100%;
                }
            }
            .content-wrap{
                .house-card-title{
                    width: 329px;
                    font-size: 20px;
                    margin-bottom: 8px;
                }
                .house-card-address{
                    display: flex;
                    align-items: center;
                    font-weight: 300;
                    margin-bottom: 8px;
                    #address-icon{
                        margin-left: 4px;
                        cursor: pointer;
                    }
                }
                .house-card-price{
                    font-size: 16px;
                    font-weight: 500;
                }
            }
        }
        
    }
    // .house-card.rented{
    //     border: solid 1px #525956;
    //     .house-card-wrap{
    //         .house-state{
    //             background-color: #525956;
    //         }
    //     }
    // }
    .house-card.loading{
        .house-card-wrap{
            .house-state{
                animation-name: loading;
                    animation-duration: 3s;
                    animation-iteration-count: infinite;
                width: 52px;
                height: 26px;
                border-radius: 2px;
                background-color: #f0f0f0;
            }
            .content-wrap{
                .house-card-title,
                .house-card-address,
                .house-card-price{
                    animation-name: loading;
                    animation-duration: 3s;
                    animation-iteration-count: infinite;
                    width: 277px;
                    height: 16px;
                    border-radius: 2px;
                    background-color: #f0f0f0;
                }
                .house-card-price{
                    width: 139px;
                }
            }
        }
        
    }
    .house-card.loading:hover{
        background: #fff;
        border: solid 1px #d5dad8;
        .house-card-wrap{
            .house-state{
                background-color: #f0f0f0;
            }
        }
    }
    .house-card:hover{
        box-shadow: 2px 2px 8px 0 rgba(41, 38, 37, 0.08);
    }
    @keyframes loading {
        0%   {opacity: 1;}
        50%  {opacity: 0.3;}
        100% {opacity: 1;}
    }
    @media screen and (max-width: 1280px) {
        .house-card{
            width: 516px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/HouseCard.vue